export const accentData = {
    "en": [
        "american",
        "australian",
        "canadian",
        "indian",
        "us northeast",
        "african american",
        "south african",
        "us southern",
        "british",
        "french",
        "received pronunciation",
        "new zealand",
        "dutch",
        "nigerian",
        "german",
        "arabic",
        "new york",
        "geordie",
        "singaporean",
        "scottish",
        "polish",
        "hindi",
        "spanish",
        "us midwest",
        "boston",
        "irish",
        "malay",
        "finnish",
        "yorkshire",
        "tamil",
        "filipino",
        "russian",
        "swedish",
        "portuguese",
        "chinese",
        "turkish",
        "chicago",
        "croatian",
        "welsh",
        "en-filipino",
        "en-indian",
        "en-american",
        "en-canadian",
        "en-british",
        "en-scottish",
        "en-nigerian",
        "jamaican",
        "italian",
        "cockney",
        "ukrainian",
        "romanian",
        "danish",
        "slovak",
        "bulgarian",
        "japanese",
        "czech",
        "indonesian",
        "korean",
        "african",
        "british"
    ],
    "es": [
        "peninsular",
        "peruvian",
        "latin american",
        "mexican",
        "colombian",
        "argentine",
        "dominican",
        "chilean",
        "andalusian",
        "cuban",
        "puerto rican",
        "ecuadorian",
        "venezuelan",
        "canary islands",
        "es-venezuelan",
        "es-colombian",
        "galician",
        "es-argentine",
        "american",
        "castillian"
    ],
    "tr": [
        "istanbul",
        "standard",
        "aegean",
        "eastern",
        "central",
        "anatolian",
        "american",
        "british"
    ],
    "fil": [
        "standard",
        "fil-standard",
        "fil-cebuano",
        "cebuano",
        "ilocano"
    ],
    "vi": [
        "southern",
        "standard",
        "northern",
        "central"
    ],
    "ar": [
        "saudi",
        "modern standard",
        "algerian",
        "egyptian",
        "palestinian",
        "jordanian",
        "gulf",
        "kuwaiti",
        "moroccan",
        "levantine"
    ],
    "fr": [
        "parisian",
        "standard",
        "quebec",
        "african",
        "swiss",
        "meridional",
        "belgian",
        "american"
    ],
    "de": [
        "standard",
        "bavarian",
        "rhine franconian",
        "berlinerisch",
        "saxon",
        "de-standard",
        "german",
        "american german"
    ],
    "pl": [
        "standard",
        "mazovian"
    ],
    "ja": [
        "standard",
        "kanto"
    ],
    "nl": [
        "flemish",
        "standard",
        "limburgish"
    ],
    "hi": [
        "standard",
        "gujarati",
        "bengali",
        "tamil",
        "bihari",
        "punjabi",
        "haryanvi",
        "indian"
    ],
    "ru": [
        "standard",
        "moscow",
        "saint petersburg"
    ],
    "it": [
        "tuscan",
        "standard",
        "milanese",
        "romanesco",
        "venetian",
        "sicilian",
        "florentine",
        "neapolitan"
    ],
    "cs": [
        "standard",
        "moravian",
        "prague"
    ],
    "pt": [
        "brazilian",
        "european",
        "african"
    ],
    "ta": [
        "chennai",
        "standard",
        "coimbatore"
    ],
    "uk": [
        "standard",
        "kiev"
    ],
    "bg": [
        "sofia",
        "standard"
    ],
    "ko": [
        "seoul",
        "jeolla",
        "standard",
        "hamgyong",
        "gyeongsang",
        "chungcheong"
    ],
    "ro": [
        "standard",
        "oltenia",
        "transylvanian"
    ],
    "ms": [
        "malaysian"
    ],
    "id": [
        "standard",
        "sundanese",
        "javanese",
        "id-standard",
        "balinese"
    ],
    "hu": [
        "standard",
        "budapest"
    ],
    "zh": [
        "taiwan mandarin",
        "beijing mandarin",
        "hong kong cantonese",
        "standard",
        "singapore mandarin"
    ],
    "no": [
        "oslo",
        "bergen",
        "standard"
    ],
    "fi": [
        "turku",
        "helsinki",
        "standard",
        "western"
    ],
    "sk": [
        "standard",
        "central"
    ],
    "sv": [
        "scanian",
        "gothenburg",
        "stockholm",
        "standard"
    ],
    "da": [
        "standard",
        "jutlandic",
        "zealandic"
    ],
    "hr": [
        "standard",
        "zagreb"
    ],
    "el": [
        "standard",
        "macedonian",
        "athenian",
        "aegean"
    ],
    "sw": [
        "standard"
    ]
}
